import PropTypes from "prop-types";

/**
 * A component that lets us define routes in React-Router even though they don't yet belong
 * to SPA.
 */
const MantaLegacyPageRedirect = ({ location }) => {
  document.body.style.display = "none";
  window.location = location.pathname;
  return null;
};

MantaLegacyPageRedirect.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string
  })
};

export default MantaLegacyPageRedirect;
